import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import type { DefaultComponentsProvider } from "~/components/article/article-render";
import type { headerNewsletterArticleArticle$key } from "~/queries/__generated__/headerNewsletterArticleArticle.graphql";

import {
  AuthorBlock,
  Container,
  Headline,
  Navigation,
  StyledNewsletterArticleBreadcrumb,
  StyledNewsletterArticleIssues,
} from "./styles";

type Props = {
  className?: string;
  provider: DefaultComponentsProvider;
  reference: headerNewsletterArticleArticle$key;
};

export const NewsletterArticleHeader: FunctionComponent<Props> = ({
  className,
  provider,
  reference,
}) => {
  const article = useFragment(
    graphql`
      fragment headerNewsletterArticleArticle on Article {
        headline
        ...issuesNewsletterArticleArticle
        ...breadcrumbNewsletterArticleArticle
        ...widgetNewsletterArticleArticle
      }
    `,
    reference,
  );

  return (
    <Container className={className}>
      <Navigation>
        <StyledNewsletterArticleBreadcrumb reference={article} />
        <StyledNewsletterArticleIssues reference={article} />
      </Navigation>
      <Headline>{article.headline}</Headline>
      <AuthorBlock>{provider.authorBlock({ firstNthAuthor: 1 })}</AuthorBlock>
    </Container>
  );
};

NewsletterArticleHeader.displayName = "NewsletterArticleHeader";
